<template>
  <div>
    <div
      class="tab-header sub-menu-header d-lg-none d-flex justify-content-between align-items-center"
    >
      <button
        type="button"
        aria-label="Close Tab"
        class="close-tab d-flex align-items-center cursor-pointer"
        @click="closeTab"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8334 10H4.16669M4.16669 10L10 15.8334M4.16669 10L10 4.16669"
            stroke="#363636"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <h4>
        {{ multiLanguage.Sale }}
      </h4>
      <button
        type="button"
        aria-label="Close Navigation"
        class="close-tab d-flex align-items-center cursor-pointer"
        @click="closeNavigation()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="#363636"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <slot name="main-sale-content"></slot>
  </div>
</template>

<script>
export default {
  name: "sale",
  props: {
    multiLanguage: Object,
  },
  methods: {
    closeTab() {
      this.$emit("close-tab", null);
    },
    closeNavigation() {
      this.$emit("close-navigation");
    },
  },
};
</script>
